/**
 *  @class
 *  @function PredictiveSearch
 */
class PredictiveSearch {
  constructor() {
    this.container = document.getElementById("Search-Drawer");
    this.form = this.container.querySelector("form.searchform");
    this.button = document.querySelectorAll(".thb-quick-search");
    this.input = this.container.querySelector('input[type="search"]');
    this.defaultTab = this.container.querySelector(
      ".side-panel-content--initial",
    );
    this.predictiveSearchResults = this.container.querySelector(
      ".side-panel-content--has-tabs",
    );

    this.setupEventListeners();
    this.setupResizeListener();

    document.addEventListener('cart-drawer:open', () => {
      this.close();
    });
  }

  setupEventListeners() {
    this.form.addEventListener("submit", this.onFormSubmit.bind(this));

    this.button.forEach((item, i) => {
      item.addEventListener("click", (event) => {
        event.preventDefault();
        this.toggle();
        return false;
      });
    });

    if (this.predictiveSearchResults) {
      this.input.addEventListener(
        "input",
        debounce((event) => {
          this.onChange(event);
        }, 300).bind(this),
      );
    }
  }

  setupResizeListener() {
    const buffer = 2;
    const mediaQueryUp = window.matchMedia(`(min-width: ${1068 + buffer}px)`);
    const mediaQueryDown = window.matchMedia(`(max-width: ${1068 - buffer}px)`);

    function handleTabletChange(e) {
      if (e.matches) {
        this.container.classList.add('resize-transition-stopper');
  
        setTimeout(() => {
          this.container.classList.remove('resize-transition-stopper');
        }, 300);
      }
    }
  
    const boundHandleTabletChange = handleTabletChange.bind(this);
  
    if (mediaQueryUp.addEventListener) {
      mediaQueryUp.addEventListener('change', boundHandleTabletChange);
    } else {
      mediaQueryUp.addListener(boundHandleTabletChange);
    }
  
    if (mediaQueryDown.addEventListener) {
      mediaQueryDown.addEventListener('change', boundHandleTabletChange);
    } else {
      mediaQueryDown.addListener(boundHandleTabletChange);
    }
  
    boundHandleTabletChange(mediaQueryUp);
    boundHandleTabletChange(mediaQueryDown);
  }

  getQuery() {
    return this.input.value.trim();
  }

  onChange() {
    const searchTerm = this.getQuery();

    if (!searchTerm.length) {
      this.predictiveSearchResults.classList.remove("active");
      return;
    }
    this.predictiveSearchResults.classList.add("active");
    this.getSearchResults(searchTerm);
  }

  onFormSubmit(event) {
    if (!this.getQuery().length) {
      event.preventDefault();
    }
  }

  onFocus() {
    const searchTerm = this.getQuery();

    if (!searchTerm.length) {
      return;
    }

    this.getSearchResults(searchTerm);
  }

  getSearchResults(searchTerm) {
    this.predictiveSearchResults.classList.add("loading");

    fetch(
      `${theme.routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&${encodeURIComponent("resources[type]")}=product,article,query&${encodeURIComponent("resources[limit]")}=10&section_id=predictive-search`,
    )
      .then((response) => {
        this.predictiveSearchResults.classList.remove("loading");
        if (!response.ok) {
          var error = new Error(response.status);
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser()
          .parseFromString(text, "text/html")
          .querySelector("#shopify-section-predictive-search").innerHTML;

        this.renderSearchResults(resultsMarkup);
      })
      .catch((error) => {
        throw error;
      });
  }

  renderSearchResults(resultsMarkup) {
    this.predictiveSearchResults.innerHTML = resultsMarkup;

    let _this = this,
      submitButton = this.container.querySelector("#search-results-submit");

    submitButton.addEventListener("click", () => {
      _this.form.submit();
    });
  }

  open() {
    document.body.classList.add("open-search", "open-cc");
    this.container.classList.add("active");
    setTimeout(() => {
      this.input.focus({ preventScroll: true });
    }, 100);
    dispatchCustomEvent("search:open");
  }

  close() {
    document.body.classList.remove("open-search");
    this.container.classList.remove("active");
    const searchInput = document.querySelector("#side-panel-search-input");
    if (searchInput) {
      searchInput.value = "";
    }

    // Only remove 'open-cc' class if cart is also closed
    if (!document.body.classList.contains("open-cart")) {
      document.body.classList.remove("open-cc");
    }
  }

  toggle() {
    if (document.body.classList.contains("open-search")) {
      this.close();
    } else {
      this.open();
    }
  }
}

new PredictiveSearch();
